import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentMedical,
  faQuestionCircle,
  faPhoneAlt,
  faSignOutAlt,
  faAngleRight,
  faCalendarCheck,
  faUserInjured,
  faShoppingBag,
  faHome,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./PatientFooter.module.css";
import clinicLogo from "../../static/logo.png";

const PatientFooter = ({ onOpenChat, onLogout }) => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        {/* ─── 1. MAIN GRID CONTENT (3 Columns) ────────────────────────── */}
        <div className={styles.mainContent}>
          {/* Column 1: Brand Anchor */}
          <div className={styles.brandCol}>
            <Link to="/patient-dashboard" className={styles.brandLogo}>
              <img
                src={clinicLogo}
                alt="ReformMe Healthcare Clinic Logo"
                className={styles.clinicLogoImg}
              />
              <div className={styles.brandTextStack}>
                <span className={styles.brandTextTop}>ReformMe</span>
                <span className={styles.brandTextBottom}>Healthcare</span>
              </div>
            </Link>
            <p className={styles.brandDesc}>
              Precision physiotherapy and holistic wellness.
              <br />
              Tailored clinical care designed for your complete recovery in Gurugram.
            </p>
          </div>

          {/* Column 2: My Portal - Post-Login Navigation */}
          <div className={styles.navCol}>
            <h3 className={styles.colTitle}>MY PORTAL</h3>
            <ul className={styles.linksList}>
              <li>
                <Link to="/patient-dashboard" className={styles.linkItem}>
                  <FontAwesomeIcon icon={faHome} style={{ color: "#2d6a4f", width: "16px" }} />
                  <span>Dashboard Home</span>
                </Link>
              </li>
              <li>
                <Link to="/myappointment" className={styles.linkItem}>
                  <FontAwesomeIcon icon={faCalendarCheck} style={{ color: "#2d6a4f", width: "16px" }} />
                  <span>My Appointments</span>
                </Link>
              </li>
              <li>
                <Link to="/patient-profile" className={styles.linkItem}>
                  <FontAwesomeIcon icon={faUserInjured} style={{ color: "#2d6a4f", width: "16px" }} />
                  <span>My Medical Profile</span>
                </Link>
              </li>
              <li>
                <Link to="/shop" className={styles.linkItem}>
                  <FontAwesomeIcon icon={faShoppingBag} style={{ color: "#2d6a4f", width: "16px" }} />
                  <span>Wellness Shop</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Patient Support & Actions */}
          <div className={styles.supportCol}>
            <h3 className={styles.colTitle}>SUPPORT & HELP</h3>

            <div className={styles.supportList}>
              <div style={{ marginBottom: "0.4rem" }}>
                <Link
                  to="/patient-dashboard"
                  onClick={(e) => {
                    if (onOpenChat && typeof onOpenChat === "function") {
                      e.preventDefault();
                      onOpenChat();
                    }
                  }}
                  className={styles.linkItem}
                >
                  <FontAwesomeIcon icon={faCommentMedical} className={styles.supportIcon} />
                  <span>Chat with Doctor</span>
                </Link>
              </div>

              <div style={{ marginBottom: "0.8rem" }}>
                <Link to="/patient-dashboard" className={styles.linkItem}>
                  <FontAwesomeIcon icon={faQuestionCircle} className={styles.supportIcon} />
                  <span>Help Center / FAQs</span>
                </Link>
              </div>

              <div className={styles.supportRow}>
                <FontAwesomeIcon icon={faPhoneAlt} className={styles.supportIcon} />
                <span>Clinic Reception: +91 9024989935</span>
              </div>
            </div>

            {/* Premium Ghost Button for Secure Logout */}
            <button
              type="button"
              onClick={() => {
                if (onLogout && typeof onLogout === "function") {
                  onLogout();
                }
              }}
              className={styles.logoutButton}
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Secure Logout</span>
            </button>
          </div>
        </div>

        {/* ─── 2. BOTTOM BAR (Security & Legal) ────────────────────────── */}
        <div className={styles.bottomBar}>
          <div>© 2026 ReformMe Healthcare. Secure Patient Portal.</div>
          <div className={styles.legalLinks}>
            <Link to="/privacy" className={styles.legalLink}>
              Privacy Policy
            </Link>
            <Link to="/terms" className={styles.legalLink}>
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PatientFooter;
